"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _idbReactUiElements = require("@identitybuilding/idb-react-ui-elements");
var _idbReactTranslations = _interopRequireDefault(require("@identitybuilding/idb-react-translations"));
var _idbReactIconlib = _interopRequireDefault(require("@identitybuilding/idb-react-iconlib"));
var _reactGoogleRecaptcha = _interopRequireDefault(require("react-google-recaptcha"));
var _function = require("../utils/function");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var Contactform = function Contactform(_ref) {
  var id = _ref.id,
    name = _ref.name,
    close = _ref.close,
    lang = _ref.lang,
    mailInfo = _ref.mailInfo,
    setSendMail = _ref.setSendMail,
    CaptchaKey = _ref.CaptchaKey;
  var env = (0, _function.getEnvEndpoints)();
  var key = CaptchaKey ? CaptchaKey : '6LeB5acZAAAAAGBmjf4P94sMnwhZM2Whd6mXk6Z1';
  var translate = function translate(e) {
    return (0, _idbReactTranslations["default"])(e, lang);
  };
  var _React$useState = _react["default"].useState(0),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    typingTimeout = _React$useState2[0],
    setTypingTimeout = _React$useState2[1];
  var fileInput = (0, _react.useRef)(null);
  var _React$useState3 = _react["default"].useState(true),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    getCopy = _React$useState4[0],
    setGetCopy = _React$useState4[1];
  var _React$useState5 = _react["default"].useState(null),
    _React$useState6 = _slicedToArray(_React$useState5, 2),
    file = _React$useState6[0],
    setFile = _React$useState6[1];
  var _React$useState7 = _react["default"].useState(null),
    _React$useState8 = _slicedToArray(_React$useState7, 2),
    base64 = _React$useState8[0],
    setBase64 = _React$useState8[1];
  var _React$useState9 = _react["default"].useState(false),
    _React$useState10 = _slicedToArray(_React$useState9, 2),
    noMessage = _React$useState10[0],
    setNoMessage = _React$useState10[1];
  var _React$useState11 = _react["default"].useState(false),
    _React$useState12 = _slicedToArray(_React$useState11, 2),
    noEmail = _React$useState12[0],
    setNoEmail = _React$useState12[1];
  var _React$useState13 = _react["default"].useState(false),
    _React$useState14 = _slicedToArray(_React$useState13, 2),
    noSubject = _React$useState14[0],
    setNoSubject = _React$useState14[1];
  var _React$useState15 = _react["default"].useState(false),
    _React$useState16 = _slicedToArray(_React$useState15, 2),
    noFName = _React$useState16[0],
    setNoFName = _React$useState16[1];
  var _React$useState17 = _react["default"].useState(false),
    _React$useState18 = _slicedToArray(_React$useState17, 2),
    noLName = _React$useState18[0],
    setNoLName = _React$useState18[1];
  var _React$useState19 = _react["default"].useState(false),
    _React$useState20 = _slicedToArray(_React$useState19, 2),
    wrongPhone = _React$useState20[0],
    setWrongPhone = _React$useState20[1];
  var _React$useState21 = _react["default"].useState(false),
    _React$useState22 = _slicedToArray(_React$useState21, 2),
    errorMessage = _React$useState22[0],
    setErrorMessage = _React$useState22[1];
  var _React$useState23 = _react["default"].useState(false),
    _React$useState24 = _slicedToArray(_React$useState23, 2),
    security = _React$useState24[0],
    setSecurity = _React$useState24[1];
  var _React$useState25 = _react["default"].useState(false),
    _React$useState26 = _slicedToArray(_React$useState25, 2),
    succesMessage = _React$useState26[0],
    setSuccesMessage = _React$useState26[1];
  var _React$useState27 = _react["default"].useState({
      email: '',
      phone: '',
      first_name: '',
      last_name: '',
      street: '',
      number: '',
      box: '',
      postal_code: '',
      municipality: '',
      subject: '',
      message: '',
      copy: getCopy,
      file: '',
      base64: ''
    }),
    _React$useState28 = _slicedToArray(_React$useState27, 2),
    data = _React$useState28[0],
    setData = _React$useState28[1];

  // Fired when typing <- or -> arrow
  var keyDownHandler = function keyDownHandler(e) {
    if (e.keyCode === 27) close();
  };
  var handleFileChange = function handleFileChange(event) {
    // if (event.target.files[0].name.substring(event.target.files[0].name.length - 4) === '.pdf'){
    var copy = data;
    setFile(event.target.files[0].name);
    copy.file = event.target.files[0].name;
    // FILE TO BASE 64--------------------------------------------
    // Create a new FileReader
    var reader = new FileReader();

    // Set the file to be read
    reader.readAsDataURL(event.target.files[0]);

    // Add an event listener to be called when the file is loaded
    reader.onload = function () {
      // The file's text will be printed here
      setBase64(reader.result);
      copy.base64 = reader.result;
    };
    // }
    // else {
    // //   props.createNotification('error', translate('only_in_pdf'))
    //   document.getElementById('cv_file').value = "";
    // }
    setData(copy);
  };
  (0, _react.useEffect)(function () {
    // function will be called when after the component mounts (ComponentDidMount)
    document.addEventListener('keydown', keyDownHandler);

    // returned function will be called on component unmount 
    return function () {
      document.removeEventListener('keydown', keyDownHandler);
    };
  });
  var dataHandler = function dataHandler(e, type) {
    var copy = data;
    if (type === 'phone') {
      // if (type === 'phone' && e.target.value.length > 2) {
      // let value = e.target.value.replace(/\//g, "")
      var value = e.target.value;
      var spaces = (value.match(/\ /g) ? value.match(/\ /g).length : 0) + (value.match(/\//g) ? value.match(/\//g).length : 0) + (value.match(/\./g) ? value.match(/\./g).length : 0);
      var filteredPhone = value.replace(/\//g, "").replace(/\ /g, "").replace(/\+/g, "").replace(/\./g, "");
      var phone_field = document.getElementsByClassName('phoneinput')[0].childNodes[0];
      var tp = 'gsm';
      if (isNaN(filteredPhone)) {
        var element = document.getElementsByName('phone')[0];
        element.classList.add('error');
        setWrongPhone(true);
        setErrorMessage(translate('invalid_phone_form'));
      } else {
        if (value.substring(0, 4) === '+324') {
          tp = 'gsm';
          phone_field.maxLength = 12 + spaces;
        } else if (value.substring(0, 2) === '04') {
          // 0400000000
          tp = 'gsm';
          phone_field.maxLength = 10 + spaces;
        } else if (value.substring(0, 4) === '0032') {
          // 0032400000000
          tp = 'gsm';
          phone_field.maxLength = 13 + spaces;
        } else {
          tp = 'tel';
          if (value.substring(0, 1) === '0') {
            phone_field.maxLength = 9 + spaces;
          } else {
            phone_field.maxLength = 10 + spaces;
          }
        }

        // Change color of the type you are using (tel or gsm)
        if (tp === 'gsm') {
          document.getElementById('gsm').style.color = 'var(--main)';
          document.getElementById('tel').style.color = 'var(--grey-70)';
        } else {
          document.getElementById('tel').style.color = 'var(--main)';
          document.getElementById('gsm').style.color = 'var(--grey-70)';
        }

        // change colors back to grey if nothing is filled in
        if (!e.target.value) {
          document.getElementById('tel').style.color = 'var(--grey-70)';
          document.getElementById('gsm').style.color = 'var(--grey-70)';
        }
        var _element = document.getElementsByName('phone')[0];
        _element.classList.remove('error');
        setWrongPhone(false);
        setErrorMessage(false);
        if (e.target.value.slice(1).includes('+')) {
          var _element2 = document.getElementsByName('phone')[0];
          _element2.classList.add('error');
          setWrongPhone(true);
          setErrorMessage(translate('invalid_phone_form'));
        }
        if (e.target.value && tp === 'gsm' && value.substring(0, 1) !== '0') {
          if (value.substring(0, 1) !== '+') {
            var _element3 = document.getElementsByName('phone')[0];
            _element3.classList.add('error');
            setWrongPhone(true);
            setErrorMessage(translate('invalid_phone_form'));
          }
        }
        if (e.target.value && tp === 'tel' && value.substring(0, 1) !== '0') {
          if (value.substring(0, 1) !== '+') {
            var _element4 = document.getElementsByName('phone')[0];
            _element4.classList.add('error');
            setWrongPhone(true);
            setErrorMessage(translate('invalid_phone_form'));
          }
        }
      }
    }
    if (type === 'email') {
      if (typingTimeout) {
        setErrorMessage('');
        setNoEmail(false);
        clearTimeout(typingTimeout);
      }
      var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (re.test(e.target.value)) {
        document.getElementsByClassName('emailinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--success)';
        document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].innerHTML = '✓';
        document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].style.color = 'var(--success)';
      } else {
        setTypingTimeout(setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                setErrorMessage(translate('invalid_email_form'));
                setNoEmail(true);
              case 2:
              case "end":
                return _context.stop();
            }
          }, _callee);
        })), 1000));
        document.getElementsByClassName('emailinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--grey-20)';
        document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
        document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
      }
    }
    // ✓
    if (type === 'first_name') {
      if (typingTimeout) {
        setErrorMessage('');
        setNoFName(false);
        clearTimeout(typingTimeout);
      }
      if (e.target.value.length === 1) {
        setTypingTimeout(setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
          return _regeneratorRuntime().wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                setErrorMessage(translate('name_to_short_form'));
                setNoFName(true);
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        })), 1000));
      }
    }
    if (type === 'last_name') {
      if (typingTimeout) {
        setErrorMessage('');
        setNoLName(false);
        clearTimeout(typingTimeout);
      }
      if (e.target.value.length === 1) {
        setTypingTimeout(setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
          return _regeneratorRuntime().wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                setErrorMessage(translate('name_to_short_form'));
                setNoLName(true);
              case 2:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        })), 1000));
      }
    }
    if (type === 'subject') {
      if (e.target.value.length > 1) {
        document.getElementsByClassName('subjectinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--success)';
        document.getElementsByClassName('subjectinput')[0].childNodes[0].childNodes[2].innerHTML = '✓';
        document.getElementsByClassName('subjectinput')[0].childNodes[0].childNodes[2].style.color = 'var(--success)';
      } else {
        document.getElementsByClassName('subjectinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--grey-20)';
        document.getElementsByClassName('subjectinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
        document.getElementsByClassName('subjectinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
      }
    }
    if (type === 'message') {
      if (e.target.value.length > 1) {
        document.getElementsByClassName('messageinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--success)';
        document.getElementsByClassName('messageinput')[0].childNodes[0].childNodes[2].innerHTML = '✓';
        document.getElementsByClassName('messageinput')[0].childNodes[0].childNodes[2].style.color = 'var(--success)';
      } else {
        document.getElementsByClassName('messageinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--grey-20)';
        document.getElementsByClassName('messageinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
        document.getElementsByClassName('messageinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
      }
    }
    Object.entries(copy).map(function (_ref5, index) {
      var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];
      // if (type === 'file') {
      //     copy[type] = e[0].fileResult
      // }
      if (type === 'phone') {
        copy[type] = e.target.value.replace(/\//g, "").replace(/\ /g, "").replace(/\+/g, "");
      } else if (key === type) {
        copy[type] = e.target.value;
      }
    });
    setData(copy);
  };
  function isValidEmail(email) {
    // Regular expression for a valid email address
    var emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    return emailRegex.test(email);
  }
  var sendData = function sendData() {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    console.log(data.email);
    console.log(isValidEmail(data.email));
    if (!data.email) {
      setNoEmail(true);
      setErrorMessage(translate('no_email_form'));
      document.getElementsByClassName('emailinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--error)';
      document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
      document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
    } else if (!isValidEmail(data.email)) {
      setErrorMessage(translate('no_valid_email'));
      document.getElementsByClassName('emailinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--error)';
      document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
      document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
    } else if (!data.subject) {
      setNoSubject(true);
      setErrorMessage(translate('no_subject_form'));
      document.getElementsByClassName('subjectinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--error)';
      document.getElementsByClassName('subjectinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
      document.getElementsByClassName('subjectinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
    } else if (!data.message) {
      setNoMessage(true);
      setErrorMessage(translate('no_message_form'));
      document.getElementsByClassName('messageinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--error)';
      document.getElementsByClassName('messageinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
      document.getElementsByClassName('messageinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
    } else if (data.email && data.message && !wrongPhone && !noFName && !noLName) {
      if (re.test(data.email)) {
        if (security) {
          setErrorMessage(translate('reCaptcha'));
        } else if (!security) {
          setNoEmail(false);
          setNoMessage(false);
          setErrorMessage(false);
          setNoFName(false);
          sendMail();
          setSuccesMessage(true);
          setTimeout(function () {
            close();
            setSendMail(true);
          }, 2000);
        }
      } else {
        setErrorMessage(translate('invalid_email_form'));
        setNoEmail(true);
        document.getElementsByClassName('emailinput')[0].childNodes[1].childNodes[0].style.border = '1px solid var(--error)';
        document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].innerHTML = '*';
        document.getElementsByClassName('emailinput')[0].childNodes[0].childNodes[2].style.color = 'var(--sub)';
      }
    }
  };
  var sendMail = function sendMail() {
    var searchParams = Object.keys(data).map(function (key) {
      return encodeURIComponent(key) + '=' + encodeURIComponent(data[key]);
    }).join('&');

    // async function postData(url = `http://192.168.0.166:8000/public/mail/BE0500973623/443261`) {
    // async function postData(url = https://api.ondernemersnetwerk.be/public/mail/BE2285183012/468426) {
    // async function postData(url = `https://api.ondernemersnetwerk.be/public/mail/${id}/${mailInfo.email}`) {
    // async function postData(url = `https://management.100procentlokaal.be/core/mail/${id}/${mailInfo.email}/`) {
    function postData() {
      return _postData.apply(this, arguments);
    }
    function _postData() {
      _postData = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var url,
          response,
          _args4 = arguments;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              url = _args4.length > 0 && _args4[0] !== undefined ? _args4[0] : "".concat(env.REACT_APP_BASE_MEDIA_URL, "/core/mail/").concat(id, "/").concat(mailInfo.email, "/");
              _context4.next = 3;
              return fetch(url, {
                method: 'POST',
                // *GET, POST, PUT, DELETE, etc.
                mode: 'no-cors',
                // no-cors, *cors, same-origin
                cache: 'no-cache',
                // *default, no-cache, reload, force-cache, only-if-cached
                credentials: 'same-origin',
                // include, *same-origin, omit
                headers: {
                  'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
                },
                redirect: 'follow',
                // manual, *follow, error
                referrerPolicy: 'no-referrer',
                // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                body: searchParams // body data type must match "Content-Type" header
              });
            case 3:
              response = _context4.sent;
              return _context4.abrupt("return", response.json());
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return _postData.apply(this, arguments);
    }
    postData("".concat(env.REACT_APP_BASE_MEDIA_URL, "/core/mail/").concat(id, "/").concat(mailInfo.email, "/"))
    // postData(`http://localhost:8000/core/mail/${id}/${mailInfo.email}/`)
    .then(function (resp) {
      // console.log(resp); // JSON data parsed by `response.json()` call
      console.log(resp);
    })["catch"](function (err) {
      return console.log(err);
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    id: "contact_form"
  }, /*#__PURE__*/_react["default"].createElement("a", {
    className: "close",
    onClick: function onClick() {
      close();
    }
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Close"
  })), /*#__PURE__*/_react["default"].createElement("h2", null, name ? translate('contact') + ' ' + name : translate('contact_us')), errorMessage ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "error_message"
  }, " ", /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Close",
    onClick: function onClick() {
      return setErrorMessage(false);
    }
  }), errorMessage, " ") : '', succesMessage ? /*#__PURE__*/_react["default"].createElement("span", {
    className: "success_message"
  }, /*#__PURE__*/_react["default"].createElement(_idbReactIconlib["default"], {
    name: "Check"
  }), " Mail succesvol verzonden! ") : '', /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50 mandatory emailinput ".concat(noEmail ? 'error' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title ".concat(data.email ? 'active' : '')
  }, translate('mail'), "  ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: 'var(--sub)'
    }
  }, "*")), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('mail'),
    onChange: function onChange(e) {
      dataHandler(e, 'email'), setNoEmail(false);
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    id: "tel"
  }, translate('phone')), " / ", /*#__PURE__*/_react["default"].createElement("span", {
    id: "gsm"
  }, translate('cellphone'))), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    className: "phoneinput",
    type: "text",
    pattern: "^-?[0-9]\\d*\\.?\\d*$",
    name: "phone",
    placeholder: translate('phone') + ' / ' + translate('cellphone'),
    onChange: function onChange(e) {
      return dataHandler(e, 'phone');
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50 ".concat(noFName ? 'error' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('firstname')), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('firstname'),
    onChange: function onChange(e) {
      return dataHandler(e, 'first_name');
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50 ".concat(noLName ? 'error' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('lastname')), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('lastname'),
    onChange: function onChange(e) {
      return dataHandler(e, 'last_name');
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: "contact_form_address"
  }, /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('street')), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('street'),
    onChange: function onChange(e) {
      return dataHandler(e, 'street');
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_25"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('no')), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('no'),
    onChange: function onChange(e) {
      return dataHandler(e, 'number');
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_25"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('box')), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('box'),
    onChange: function onChange(e) {
      return dataHandler(e, 'box');
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('postal_code')), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    maxLength: "4",
    placeholder: translate('postal_code'),
    onChange: function onChange(e) {
      return dataHandler(e, 'postal_code');
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('municipality')), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('municipality'),
    onChange: function onChange(e) {
      return dataHandler(e, 'municipality');
    }
  }))), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_100 mandatory subjectinput ".concat(noSubject ? 'error' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('reason_of_contact'), "  ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: 'var(--sub)'
    }
  }, "*")), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnInputText, {
    placeholder: translate('reason_of_contact'),
    onChange: function onChange(e) {
      dataHandler(e, 'subject'), setNoSubject(false);
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_100 mandatory messageinput ".concat(noMessage ? 'error' : '')
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('contact_message'), "  ", /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: 'var(--sub)'
    }
  }, "*")), /*#__PURE__*/_react["default"].createElement(_idbReactUiElements.OsnTextarea, {
    placeholder: translate('contact_message'),
    resize: true,
    onChange: function onChange(e) {
      dataHandler(e, 'message'), setNoMessage(false);
    }
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50 input"
  }, /*#__PURE__*/_react["default"].createElement("span", {
    className: "label_title"
  }, translate('media_files')), /*#__PURE__*/_react["default"].createElement("input", {
    type: "file",
    ref: fileInput,
    onChange: handleFileChange,
    className: "cv_upload",
    id: "cv_file"
  })), /*#__PURE__*/_react["default"].createElement("label", {
    className: "label_50 recaptcha"
  }, /*#__PURE__*/_react["default"].createElement(_reactGoogleRecaptcha["default"], {
    sitekey: key,
    onChange: function onChange() {
      return setSecurity(false);
    }
  })), /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      paddingBottom: '10px',
      width: '100%',
      margin: '7px 15px'
    }
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "form_button",
    onClick: function onClick() {
      return succesMessage === false && sendData();
    }
  }, translate('send'))), /*#__PURE__*/_react["default"].createElement("div", {
    className: "bi_bg",
    onClick: function onClick() {
      return close();
    }
  }), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      color: 'var(--grey-90)',
      fontSize: '12px',
      margin: '0 15px'
    }
  }, translate('copy_email')));
};
var _default = exports["default"] = Contactform;